import React from 'react';
import { Container, Typography, Paper, Box } from '@mui/material';
import { HeadphonesIcon, ShoppingBag } from 'lucide-react';

const Contact = () => {
  const contacts = [
    { 
      number: '+34 632 22 08 54', 
      type: 'sales', 
      label: 'Ventas',
      icon: ShoppingBag,
      description: 'Información sobre productos'
    },
    { 
      number: '+34 632 22 08 54', 
      type: 'support', 
      label: 'Soporte',
      icon: HeadphonesIcon,
      description: 'Asistencia técnica y soporte'
    }
  ];

  const handleWhatsAppClick = (phoneNumber: string) => {
    const formattedNumber = phoneNumber.replace(/\s+/g, '');
    window.open(`https://wa.me/${formattedNumber}`, '_blank');
  };

  return (
    <div className="py-16">
      <Container maxWidth="lg">
        <Typography 
          variant="h1" 
          align="center" 
          className="text-[#00ff00] text-6xl md:text-7xl font-bold mb-6"
          sx={{
            textShadow: '0 0 10px rgba(0, 255, 0, 0.7), 0 0 20px rgba(0, 255, 0, 0.5)',
            animation: 'glow 2s ease-in-out infinite alternate',
            '@keyframes glow': {
              '0%': { textShadow: '0 0 10px rgba(0, 255, 0, 0.7), 0 0 20px rgba(0, 255, 0, 0.5)' },
              '100%': { textShadow: '0 0 20px rgba(0, 255, 0, 0.9), 0 0 30px rgba(0, 255, 0, 0.7)' }
            }
          }}
        >
          Contacto
        </Typography>

        <Typography 
          variant="h5" 
          align="center" 
          className="text-[#00ffff] mb-16"
          sx={{
            textShadow: '0 0 8px rgba(0, 255, 255, 0.5)',
            maxWidth: '800px',
            mx: 'auto'
          }}
        >
          Estamos aquí para ayudarte. Nuestro equipo está disponible vía WhatsApp.
        </Typography>

        <Box sx={{ 
          display: 'flex', 
          flexWrap: 'wrap', 
          gap: 4, 
          justifyContent: 'center',
          maxWidth: 1200,
          mx: 'auto'
        }}>
          {contacts.map((contact, index) => (
            <Paper
              key={index}
              sx={{
                p: 4,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                flex: '1 1 300px',
                maxWidth: 380,
                backgroundColor: 'rgba(0, 0, 0, 0.6)',
                border: '1px solid',
                borderColor: contact.type === 'support' ? '#00ff00' : '#ff00ff',
                borderRadius: 4,
                transition: 'all 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: contact.type === 'support' 
                    ? '0 0 20px rgba(0, 255, 0, 0.3)' 
                    : '0 0 20px rgba(255, 0, 255, 0.3)',
                },
              }}
            >
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  bgcolor: 'transparent',
                  border: '2px solid',
                  borderColor: contact.type === 'support' ? '#00ff00' : '#ff00ff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 2,
                  boxShadow: contact.type === 'support'
                    ? '0 0 15px rgba(0, 255, 0, 0.3)'
                    : '0 0 15px rgba(255, 0, 255, 0.3)',
                }}
              >
                {React.createElement(contact.icon, { 
                  size: 40, 
                  color: contact.type === 'support' ? '#00ff00' : '#ff00ff',
                  strokeWidth: 1.5 
                })}
              </Box>

              <Typography 
                variant="h5" 
                align="center" 
                sx={{ 
                  color: contact.type === 'support' ? '#00ff00' : '#ff00ff',
                  textShadow: contact.type === 'support'
                    ? '0 0 10px rgba(0, 255, 0, 0.5)'
                    : '0 0 10px rgba(255, 0, 255, 0.5)',
                }}
              >
                {contact.label}
              </Typography>

              <Typography 
                variant="body1" 
                align="center" 
                sx={{ 
                  color: '#00ffff',
                  mb: 2,
                  opacity: 0.8
                }}
              >
                {contact.description}
              </Typography>

              <Typography 
                variant="h6" 
                align="center" 
                sx={{ 
                  fontFamily: 'monospace',
                  letterSpacing: 1,
                  color: contact.type === 'support' ? '#00ff00' : '#ff00ff',
                }}
              >
                {contact.number}
              </Typography>

              <button
                onClick={() => handleWhatsAppClick(contact.number)}
                className={`mt-4 px-6 py-3 rounded-lg font-semibold text-black transition-all duration-300
                  ${contact.type === 'support' 
                    ? 'bg-[#00ff00] hover:bg-[#00cc00] shadow-[0_0_15px_rgba(0,255,0,0.3)]' 
                    : 'bg-[#ff00ff] hover:bg-[#cc00cc] shadow-[0_0_15px_rgba(255,0,255,0.3)]'
                  }
                  flex items-center gap-2
                `}
              >
                <svg 
                  viewBox="0 0 24 24" 
                  width="20" 
                  height="20" 
                  stroke="currentColor" 
                  fill="none" 
                  strokeWidth="2" 
                  strokeLinecap="round" 
                  strokeLinejoin="round"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                </svg>
                Contactar por WhatsApp
              </button>
            </Paper>
          ))}
        </Box>

        <Typography 
          variant="body2" 
          align="center" 
          sx={{ 
            mt: 8,
            color: '#00ffff',
            opacity: 0.7,
            textShadow: '0 0 5px rgba(0, 255, 255, 0.3)'
          }}
        >
          Horario de atención: Lunes a Domingo de 9:00 a 21:00
        </Typography>
      </Container>
    </div>
  );
};

export default Contact;
